/* unplugin-vue-components disabled */import { render } from "./Logo.vue?vue&type=template&id=4617869e"
const script = {}

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__